import { Button, UncontrolledTooltip } from 'reactstrap';
import { useTranslation } from 'react-i18next';

export const UnprocessedHeadingTooltip = () => {
  const { t } = useTranslation();
  return (
    <>
      {' '}
      <Button
        id={'unprocessedInfoButton'}
        size="lg"
        color="none"
        className="position-absolute heading-tooltip border-0"
      >
        <i className="fa fa-question-circle text-muted"></i>
      </Button>
      <UncontrolledTooltip
        target={'unprocessedInfoButton'}
        placement="bottom-start"
        container="body"
        delay={{ show: 50, hide: 50 }}
        style={{
          minWidth: '600px',
          backgroundColor: 'var(--balance-profie-bg)',
        }}
      >
        <div className="d-flex flex-column text-start">
          {/* <p className="p-0 m-0">{t('control.unprocessed.headingTooltip.description')}</p> */}
          <div>
            {/* <p className="p-0 m-0">
              <span className="f-w-700 d-inline">
                {t('control.crmTable.headingTooltip.reason')}{' '}
              </span>
              {t('control.crmTable.headingTooltip.reasonNames')}
            </p> */}
            <p className="p-0 mb-1 mt-2">
              {' '}
              <span className="f-w-700 d-inline">
                {' '}
                {t('control.unprocessed.headingTooltip.statuses')}{' '}
              </span>
            </p>
            <ul className="mb-0 ps-4 d-flex flex-column gap-1" style={{ listStyle: 'initial' }}>
              <li>
                {' '}
                <span className="f-w-700 d-inline">
                  {t('control.unprocessed.transcriptionProcessStatus.in_progress')}
                  {': '}
                </span>{' '}
                {t('control.unprocessed.headingTooltip.in_progress')}
              </li>
              <li>
                <span className="f-w-700 d-inline">
                  {t('control.unprocessed.transcriptionProcessStatus.call_completed')}
                  {': '}
                </span>{' '}
                {t('control.unprocessed.headingTooltip.call_completed')}
              </li>
              <li>
                <span className="f-w-700 d-inline">
                  {t('control.unprocessed.transcriptionProcessStatus.leave_error')}
                  {': '}
                </span>{' '}
                {t('control.unprocessed.headingTooltip.leave_error')}
              </li>
              <li>
                <span className="f-w-700 d-inline">
                  {t('control.unprocessed.transcriptionProcessStatus.left_meeting_normal')}
                  {': '}
                </span>{' '}
                {t('control.unprocessed.headingTooltip.left_meeting_normal')}
              </li>
              <li>
                <span className="f-w-700 d-inline">
                  {t('control.unprocessed.transcriptionProcessStatus.failed_after_call')}
                  {': '}
                </span>{' '}
                {t('control.unprocessed.headingTooltip.failed_after_call')}
              </li>
              <li>
                <span className="f-w-700 d-inline">
                  {t('control.unprocessed.transcriptionProcessStatus.defective')}
                  {': '}
                </span>{' '}
                {t('control.unprocessed.headingTooltip.defective')}
              </li>
              <li>
                <span className="f-w-700 d-inline">
                  {t('control.unprocessed.transcriptionProcessStatus.renewed')}
                  {': '}
                </span>{' '}
                {t('control.unprocessed.headingTooltip.renewed')}
              </li>
              <li>
                <span className="f-w-700 d-inline">
                  {t('control.unprocessed.transcriptionProcessStatus.fail_to_queued')}
                  {': '}
                </span>{' '}
                {t('control.unprocessed.headingTooltip.fail_to_queued')}
              </li>
              <li>
                <span className="f-w-700 d-inline">
                  {t('control.unprocessed.transcriptionProcessStatus.queued_to_score')}
                  {': '}
                </span>{' '}
                {t('control.unprocessed.headingTooltip.queued_to_score')}
              </li>
              <li>
                <span className="f-w-700 d-inline">
                  {t('control.unprocessed.transcriptionProcessStatus.counted_lengths')}
                  {': '}
                </span>{' '}
                {t('control.unprocessed.headingTooltip.counted_lengths')}
              </li>
              {/* <li>
                <span className="f-w-700 d-inline">
                  {t('control.unprocessed.transcriptionProcessStatus.failed_to_count_lengths')}
                  {': '}
                </span>{' '}
                {t('control.unprocessed.headingTooltip.failed_to_count_lengths')}
              </li> */}
              <li>
                <span className="f-w-700 d-inline">
                  {t('control.unprocessed.transcriptionProcessStatus.fail_on_score')}
                  {': '}
                </span>{' '}
                {t('control.unprocessed.headingTooltip.fail_on_score')}
              </li>
            </ul>
          </div>
        </div>
      </UncontrolledTooltip>
    </>
  );
};
